// extracted by mini-css-extract-plugin
export default {"btnEdit":"AssessorNotTaxYearForm_btnEdit__zW+oh","textTitle":"AssessorNotTaxYearForm_textTitle__PaIu5","divider1":"AssessorNotTaxYearForm_divider1__5tLmn"};